<template>
    <div>
        <!-- Search Section -->
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
                <!-- Updated flex container with justify-content: space-between -->
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem; margin-top: 1rem; justify-content: space-between">
                    <div style="flex: 1; min-width: 300px" class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="provinceOptions">{{ $t('province') }}</label>
                            <Dropdown
                                v-model="selectedProvince"
                                :options="provinceOptions"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="amphurOptions">{{ $t('amphur') }}</label>
                            <Dropdown
                                :disabled="isDisabledAmphur == 1"
                                v-model="selectedAmphur"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="tambonOptions">{{ $t('tambon') }}</label>
                            <Dropdown
                                :disabled="isDisabledTambon == 1"
                                v-model="selectedTambon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label>{{ $t('ชุมชน') }}</label>
                            <Dropdown
                                v-model="communitySelect"
                                :options="communityOptions"
                                optionLabel="community_name"
                                :dataKey="'community_id'"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <!-- Template for the selected value -->
                                <template #value="slotProps">
                                    <div v-if="slotProps.value">
                                        <div>{{ slotProps.value.community_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>
                                <!-- Template for each option -->
                                <template #option="slotProps">
                                    <div class="EV_communityOptions">
                                        {{ slotProps.option.community_name }}
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="error_communitySelect" class="p-error">{{ $t('invalid_communitySelect') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label>{{ $t('ประเภทชุมชน') }}</label>
                            <Dropdown
                                v-model="type_detail"
                                :options="type_detailOption"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="type_detailOption">
                                    <div v-if="type_detailOption.value">
                                        <div>{{ type_detailOption.value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="type_detailOption">
                                    <div>{{ type_detailOption.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-4">
                                <div style="display: flex; flex-direction: row" class="p-field p-col-12 p-mt-2">
                                    <Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-mr-3" />
                                    <Button @click="initialData()" :label="$t('searchBtn')" class="p-button-info p-mr-2" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-container" style="flex: 1; min-width: 300px">
                        <div class="stat-item">
                            <span class="stat-label">วันที่ค้นหาข้อมูล</span>
                            <strong class="stat-value">{{ getCurrentThaiDate() }}</strong>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">จำนวนชุมชนทั้งหมด</span>
                            <strong class="stat-value">{{ Number(summaryTable.length).toLocaleString('en-US') }}</strong>
                            <span class="stat-note">ชุมชน</span>
                        </div>
                        <!-- <div class="stat-item">
                            <span class="stat-label">จำนวนการจัดการข้อมูล</span>
                            <strong class="stat-value">{{ Number(totalRecords).toLocaleString('en-US') }}</strong>
                            <span class="stat-note">รายการ</span>
                        </div> -->
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="actionLogs_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <!-- Flex Container for Both Tables -->
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem; margin-top: 1rem">
            <!-- Summary Table -->
            <div style="flex: 1; min-width: 300px">
                <div class="card p-fluid p-mt-2">
                    <DataTable
                        :value="summaryTable"
                        class="styled-table"
                        :scrollable="true"
                        scrollHeight="500px"
                        ref="dt1"
                        :exportFilename="`รายงานสรุปจำนวนชุมชนที่มีการนำเข้าข้อมูลทรัพยากร-${date}`"
                        sortField="index_1"
                        :sortOrder="1"
                        dataKey="id"
                        :paginator="true"
                        :selection.sync="selectedSummaryLogs"
                        :filters="filters_1"
                        :rows="10"
                        :rowHover="true"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 20, 50]"
                        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                        :loading="loading"
                    >
                        <template #header>
                            <div class="p-grid p-col">
                                <div class="table-header" style="padding: 7px">
                                    <Button @click="exportCSV1()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                                </div>
                                <div class="table-header" style="padding: 7px">
                                    <SplitButton
                                        label="ส่งออก PDF"
                                        :model="items_1"
                                        class="p-button-raised p-button-danger"
                                        style="background-color: #f33737"
                                    ></SplitButton>
                                </div>
                                <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                                    <Button
                                        @click="EditPDF_1()"
                                        icon="pi pi-cog"
                                        :label="'ตั้งค่า'"
                                        style="background-color: #0288d1; border: 1px solid #0288d1"
                                    />
                                </div>
                                <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                                    <span class="p-input-icon-left" v-if="columns_disabled">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filter_1" @input="searchTable_1()" :placeholder="$t('searchHeader')" />
                                    </span>
                                    <span class="p-input-icon-left" v-else>
                                        <i class="pi pi-search" />
                                        <InputText disabled v-model="filter_1" @input="searchTable_1()" :placeholder="$t('searchHeader')" />
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>{{ $t('TableEmpty') }}</template>
                        <Column field="index_1" header="ลำดับ" headerStyle="width: 4rem">
                            <template #body="slotProps">
                                {{ slotProps.data.index_1 }}
                            </template>
                        </Column>

                        <Column field="community_name" :header="$t('ชุมชน')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.community_name == null">-</div>
                                {{ slotProps.data.community_name }}
                            </template>
                        </Column>

                        <Column field="type_detail" :header="$t('ประเภทชุมชน')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.type_detail == null">-</div>
                                {{ slotProps.data.type_detail }}
                            </template>
                        </Column>

                        <Column field="extinguisher" :header="$t('ถังดับเพลิง')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.extinguisher == null">-</div>
                                {{ Number(slotProps.data.extinguisher).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="portableFirepumpCount" :header="$t('เครื่องดับเพลิงชนิดหาบหาม')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.portableFirepumpCount == null">-</div>
                                {{ Number(slotProps.data.portableFirepumpCount).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="fireHydrantCount" :header="$t('ปะปาหัวแดง')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.fireHydrantCount == null">-</div>
                                {{ Number(slotProps.data.fireHydrantCount).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="equipmentVehicleCount" :header="$t('อุปกรณ์ยานพาหนะ')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.equipmentVehicleCount == null">-</div>
                                {{ Number(slotProps.data.equipmentVehicleCount).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="volunteerCount" :header="$t('อาสาสมัคร')" :sortable="true" headerStyle="width: 15rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.volunteerCount == null">-</div>
                                {{ Number(slotProps.data.volunteerCount).toLocaleString('en-US') }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>

        <!-- Other Dialogs -->
        <Dialog
            :modal="true"
            :header="$t('OrganizeModalHeader')"
            :visible.sync="showOrganize"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
        >
            <organize-table @selectOrganization="selectedOrganize_passValue"></organize-table>
        </Dialog>

        <Dialog :header="$t('json')" :visible.sync="displayInfo" :style="{ width: 'max-content' }">
            <div class="p-mt-5 p-mb-5">
                <pre id="json"></pre>
            </div>
        </Dialog>

        <!-- Edit PDF Dialog -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>

        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF_1" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog_1"
                            :options="columns_1"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue_1"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF_1();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF_1()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF_1()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF_1()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import organizeTable from '../../Information/OrganizeTable.vue';
import moment from 'moment';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'report-logs',
    components: {
        organizeTable,
        textFooter
    },
    data() {
        return {
            columns_type_detail: true,
            type_detail: null,
            type_detailOption: [],
            // type:"",
            icommu_type_detail: null,
            icommu_type_detailOption: [],
            error_icommu_type_detail: false,
            icommu_type: '',
            isDisabledTambon: 1,
            isDisabledAmphur: 1,
            selectedProvince: null,
            selectedAmphur: null,
            amphurOptions: [],
            selectedTambon: null,
            tambonOptions: [],
            provinceOptions: [],
            communitySelect: null,
            communityOptions: [],
            error_communitySelect: false,
            dropdownClearFilerValue: 0,
            loading: false,

            filter_1: '',
            allSummaryTable: [],
            queryTime: moment().locale('th').add(543, 'year').format('l'),
            totalRecords: 0,
            summaryPercentage: [],
            multiSelectClearFilerValue_1: 0,
            index: 1,
            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            count: false,
            cloneTable: [],
            cloneTable_1: [],
            // Doe ค้นหา  2/5 จบ

            selectedActionLogs: null,
            selectedSummaryLogs: null,
            actionLogs_table: [],
            filters: {},
            filters_1: {},
            showOrganize: false,
            selectedOrganize: {
                id: null,
                name: ''
            },
            dateYear: '',
            starttime: null,
            endtime: null,
            displayInfo: false,
            infoText: null,

            errorStartTime: false,
            errorEndTime: false,

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'รายงานสถานีดับเพลิงและกู้ภัยที่มีการตรวจสอบและรายงานสถานะข้อมูลยานพาหนะ และเครื่องมืออุปกรณ์',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 15,
            PDF_FontBodyVer: 12,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 },
                user_fullname: { cellWidth: 80 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'หน่วยงาน', dataKey: 'fs_tname' },
                { title: 'วันเวลาที่จัดการข้อมูล', dataKey: 'date' },
                { title: 'การจัดการ', dataKey: 'topic' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_fs_tname: true,
            columns_user_fullname: true,
            columns_action_type: true,
            columns_action_time: true,
            columns_topic: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe PDF เลือกได้  2/5
            setPDF_Hor_1: 'l',
            setPosition_Hor_1: [802, 34, 802, 570],
            setPDF_Ver_1: 'p',
            setPosition_Ver_1: [570, 34, 575, 815],
            setPDF_Styles_1: 'grid',
            setnamePDF_1: 'รายงานสรุปจำนวนชุมชนที่มีการนำเข้าข้อมูลทรัพยากร',
            setPDF_fillColor_1: [95, 154, 250],
            setPDF_Margin_1: { left: 15, right: 15 },

            PDF_minCellWidthVer_1: 70,
            PDF_FontHeaderVer_1: 15,
            PDF_FontBodyVer_1: 12,

            PDF_BodySizeSelect_1: {},
            PDF_BodySize_1: {
                index: { cellWidth: 35 },
                user_fullname: { cellWidth: 80 }
            },

            PDF_minCellWidthHor_1: 70,
            PDF_FontHeaderHor_1: 15,
            PDF_FontBodyHor_1: 12,

            PDF_BodySizeHorSelect_1: {},
            PDF_BodySizeHor_1: {
                index: { cellWidth: 35 }
            },
            columns_1: [
                { title: 'ลำดับ', dataKey: 'index_1' },
                { title: 'ชุมชน', dataKey: 'community_name' },
                { title: 'ประเภทชุมชน', dataKey: 'type_detail' },
                { title: 'ถังดับเพลิง', dataKey: 'extinguisher' },
                { title: 'เครื่องดับเพลิงชนิดหาบหาม', dataKey: 'portableFirepumpCount' },
                { title: 'ปะปาหัวแดง', dataKey: 'fireHydrantCount' },
                { title: 'อุปกรณ์ยานพาหนะ', dataKey: 'equipmentVehicleCount' },
                { title: 'อาสาสมัคร', dataKey: 'volunteerCount' }
            ],

            columnsSelector_1: null,
            columnsSelectorDialog_1: null,

            displayEditPDF_1: false,

            index_1: 1,
            columns_index_1: true,
            columns_fs_tname_1: true,
            columns_user_fullname_1: true,
            columns_action_type_1: true,
            columns_action_time_1: true,
            columns_topic_1: true,

            columns_disabled_1: true,
            GetData_ColumnsSearch_1: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'สังกัด',
                    textShow: ''
                },
                {
                    DataName: 'เวลาเริ่มต้น',
                    textShow: ''
                },
                {
                    DataName: 'เวลาสิ้นสุด',
                    textShow: ''
                }
            ],
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ],
            items_1: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns_1 = this.columnsSelector_1;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver_1,
                            setPosition: this.setPosition_Ver_1,
                            PDF_Styles: this.setPDF_Styles_1,
                            data: this.$refs.dt1.processedData,
                            columns: columns_1,
                            columnsStyles: this.PDF_BodySizeSelect_1,
                            FileName: this.setnamePDF_1,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer_1,
                            Body_FontSize: this.PDF_FontBodyVer_1,
                            minCell: this.PDF_minCellWidthVer_1,
                            marginPDF: this.setPDF_Margin_1,
                            fillColorPDF: this.setPDF_fillColor_1
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns_1 = this.columnsSelector_1;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Hor_1,
                            setPosition: this.setPosition_Hor_1,
                            PDF_Styles: this.setPDF_Styles_1,
                            data: this.$refs.dt1.processedData,
                            columns: columns_1,
                            columnsStyles: this.PDF_BodySizeHorSelect_1,
                            FileName: this.setnamePDF_1,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor_1,
                            Body_FontSize: this.PDF_FontBodyHor_1,
                            minCell: this.PDF_minCellWidthHor_1,
                            marginPDF: this.setPDF_Margin_1,
                            fillColorPDF: this.setPDF_fillColor_1
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        selectedOrganize(val) {
            if (val != '') {
                this.showOrganize = false;
            }
        },

        displayInfo(val) {
            if (val) {
                setTimeout(() => {
                    document.getElementById('json').textContent = JSON.stringify(JSON.parse(this.infoText), undefined, 2);
                }, 500);
            }
        },

        starttime(val) {
            if (val) {
                this.errorStartTime = false;
            }
        },
        endtime(val) {
            if (val) {
                this.errorEndTime = false;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.actionLogs_table = [];
            } else {
                this.actionLogs_table = this.cloneTable;
            }
        },
        columnsSelector_1(val) {
            if (val.length == 0) {
                this.summaryTable.summaryPercentage = [];
            } else {
                this.summaryTable.summaryPercentage = this.cloneTable_1;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            this.communitySelect = null; // Reset community selection

            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        this.amphurOptions = response.data.data;
                        // this.amphurOptions.splice(0, 0, {
                        //     amphur_id: 'getall',
                        //     amphur_name: this.$i18n.t('selectAll')
                        // });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
                await this.initialCommunityData(); // Reset to all communities
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            this.communitySelect = null; // Reset community selection

            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        this.tambonOptions = response.data.data;
                        // this.tambonOptions.splice(0, 0, {
                        //     tambon_id: 'getall',
                        //     tambon_name: this.$i18n.t('selectAll')
                        // });
                    });

                // Update community options based on selected amphur
                await this.updateCommunityOptions(val.amphur_name);
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
                await this.initialCommunityData(); // Reset to all communities
            }
        }
    },
    created() {
        const yy = new Date();
        const yyyy = parseInt(yy.getFullYear()) + 543;
        this.dateYear = yyyy;
        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // Doe PDF เลือกได้  4/5  จบ

        this.initialData();

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },
    mounted() {
        this.initialCommunityData();
        this.initialCommunityType();
        this.runSequentially();
    },
    methods: {
        async initialCommunityType() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-24' }
                });
                this.type_detailOption = response.data.data;
            } catch (error) {
                console.error('Error fetching community type options:', error);
            } finally {
                this.loading = false;
            }
        },

        async initialCommunityData() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.selectedAmphur ? this.selectedAmphur.amphur_name : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching community options:', error);
            } finally {
                this.loading = false;
            }
        },

        async updateCommunityOptions(amphur) {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.selectedAmphur ? this.selectedAmphur.amphur_name : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching filtered community options:', error);
            } finally {
                this.loading = false;
            }
        },

        getCurrentThaiDate() {
            return moment().locale('th').add(543, 'year').format('D MMMM YYYY');
        },

        convertDateToThaiFormat(dateString) {
            return moment(dateString).locale('th').add(543, 'year').format('D MMMM YYYY [เวลา] HH:mm');
        },

        async runSequentially() {
            this.SelectAllEditPDF_1();
            this.SaveEditPDF_1();
            await this.initialData();
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        exportCSV1() {
            // Use the exportCSV method from the DataTable component
            this.$refs.dt1.exportCSV();
        },

        // Doe ค้นหา  3/6
        searchTable() {
            this.ms = true;
            // Normalize the filter string for case-insensitive search.
            const searchTerm = this.filter ? this.filter.toLowerCase().trim() : '';

            if (searchTerm !== '') {
                this.actionLogs_table = this.cloneTable.filter((item) => {
                    // Normalize the fields and replace null values with '-'
                    const organize_name =
                        item.organize_name == null || item.organize_name === 'null' ? '-' : String(item.organize_name).toLowerCase();
                    const user_username =
                        item.user_username == null || item.user_username === 'null' ? '-' : String(item.user_username).toLowerCase();
                    const user_fullname =
                        item.user_fullname == null || item.user_fullname === 'null' ? '-' : String(item.user_fullname).toLowerCase();
                    const action_time = item.action_time ? String(item.action_time).toLowerCase() : '';
                    const topic = item.topic ? String(item.topic).toLowerCase() : '';
                    const fs_tname = item.fs_tname ? String(item.fs_tname).toLowerCase() : '-';

                    // Return true if any enabled column contains the search term.
                    return (
                        (this.columns_fs_tname && fs_tname.includes(searchTerm)) ||
                        (this.columns_user_fullname && user_fullname.includes(searchTerm)) ||
                        (this.columns_action_type && organize_name.includes(searchTerm)) ||
                        (this.columns_action_time && action_time.includes(searchTerm)) ||
                        (this.columns_topic && topic.includes(searchTerm)) ||
                        // If you want to search in the username as well, you can add:
                        (this.columns_fs_tname && user_username.includes(searchTerm))
                    );
                });
            } else {
                // No search term, so show the full table.
                this.actionLogs_table = [...this.cloneTable];
            }

            // Update the index property for pagination or display.
            this.actionLogs_table = this.actionLogs_table.map((item, index) => ({
                ...item,
                index: index + 1
            }));
        },

        searchTable_1() {
            this.ms = true;
            const searchTerm = this.filter_1 ? this.filter_1.toLowerCase().trim() : '';
            // console.log("filter_1:", this.filter_1, "searchTerm:", searchTerm);

            if (searchTerm !== '') {
                this.summaryTable = this.cloneTable_1.filter((item) => {
                    const community_name =
                        item.community_name == null || item.community_name === 'null' ? '-' : String(item.community_name).toLowerCase();
                    return community_name.includes(searchTerm);
                });
            } else {
                this.summaryTable = [...this.cloneTable_1];
            }

            this.summaryTable = this.summaryTable.map((item, index) => ({
                ...item,
                index_1: index + 1
            }));
            // console.log("updated summaryTable:", this.summaryTable);

            // Force Vue to re-render if needed.
            this.$forceUpdate();
        },

        // Doe ค้นหา  3/6 จบ

        async initialData() {
            // console.log('Selected type_detail:', this.type_detail);
            this.filter = '';
            this.filter_1 = '';
            this.cloneTable = [];
            this.summaryTable = [];

            this.loading = true;

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    this.provinceOptions = response.data.data;
                    // this.provinceOptions.splice(0, 0, {
                    //     province_id: 'getall',
                    //     province_name: this.$i18n.t('selectAll')
                    // });
                });
            await this.axios
                .post(`${this.$url_service}/community/resources/report-1`, {
                    province: this.selectedProvince?.province_name || undefined,
                    district: this.selectedAmphur?.amphur_name || undefined,
                    subDistrict: this.selectedTambon?.tambon_name || undefined,
                    community_name: this.communitySelect?.community_name || undefined,
                    type_detail: this.type_detail?.system_name || undefined
                })

                .then((response) => {
                    // Check if response.data.data is an array; if not, wrap it into one.
                    const data = response.data.data;
                    this.cloneTable_1 = Array.isArray(data)
                        ? data.map((item, index) => ({ ...item, index_1: index + 1 }))
                        : [{ ...data, index_1: 1 }];

                    // Update footer search text.
                    this.setSearchText_Footer();
                });

            // Depending on the columns_disabled flag, set the table data appropriately
            if (this.columns_disabled === true) {
                this.actionLogs_table = this.cloneTable;
                this.summaryTable = this.cloneTable_1;
            } else {
                this.actionLogs_table = [];
            }

            this.loading = false;
        },

        setSearchText_Footer() {
            this.text_Footer = false;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.selectedOrganize.name !== '' || this.starttime !== null || this.endtime !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'สังกัด' && this.selectedOrganize.name !== '') {
                        element.textShow = this.selectedOrganize.name;
                    }
                    if (element.DataName === 'เวลาเริ่มต้น' && this.starttime !== null) {
                        element.textShow = this.setDate(this.starttime);
                    }
                    if (element.DataName === 'เวลาสิ้นสุด' && this.endtime !== null) {
                        element.textShow = this.setDate(this.endtime);
                    }

                    this.text_Footer = true;
                }
            }
        },
        setDate(date) {
            if (typeof date === 'object') {
                const Thai_date = date.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });
                return Thai_date;
            } else {
                return date;
            }
        },
        selectedOrganize_passValue(variable) {
            this.selectedOrganize = {
                id: variable.organize_id,
                name: variable.organize_name
            };
        },

        clearSearchField() {
            this.selectedOrganize = { id: null, name: '' };
            this.starttime = null;
            this.endtime = null;
            this.initialData();
            this.filter = '';
            this.cloneTable = [];
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    user_fullname: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor = 90;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_fs_tname = false;
                this.columns_user_fullname = false;
                this.columns_action_type = false;
                this.columns_action_time = false;
                this.columns_topic = false;

                this.columns_disabled = false;
            } else if (this.columnsSelectorDialog.length == 6) {
                this.columns_index = true;
                this.columns_fs_tname = true;
                this.columns_user_fullname = true;
                this.columns_action_type = true;
                this.columns_action_time = true;
                this.columns_topic = true;

                this.columns_disabled = true;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    getData.push(this.columnsSelector[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'user_username') {
                        this.columns_fs_tname = true;
                    } else if (!getData.includes('user_username')) {
                        this.columns_fs_tname = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_action_type = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_action_type = false;
                    }

                    if (element == 'action_time') {
                        this.columns_action_time = true;
                    } else if (!getData.includes('action_time')) {
                        this.columns_action_time = false;
                    }

                    if (element == 'topic') {
                        this.columns_topic = true;
                    } else if (!getData.includes('topic')) {
                        this.columns_topic = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        },

        EditPDF_1() {
            this.displayEditPDF_1 = true;
            this.columnsSelectorDialog_1 = this.columnsSelector_1;
        },
        SaveEditPDF_1() {
            if (this.columnsSelectorDialog_1.length <= 4) {
                this.PDF_minCellWidthVer_1 = 120;
                this.PDF_FontHeaderVer_1 = 15;
                this.PDF_FontBodyVer_1 = 12;

                this.PDF_BodySizeSelect_1 = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor_1 = 130;
                this.PDF_FontHeaderHor_1 = 15;
                this.PDF_FontBodyHor_1 = 12;

                this.PDF_BodySizeHorSelect_1 = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog_1.length <= 6) {
                this.PDF_minCellWidthVer_1 = 70;
                this.PDF_FontHeaderVer_1 = 15;
                this.PDF_FontBodyVer_1 = 12;
                this.PDF_BodySizeSelect_1 = {
                    index: { cellWidth: 35 },
                    user_fullname: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor_1 = 90;
                this.PDF_FontHeaderHor_1 = 15;
                this.PDF_FontBodyHor_1 = 12;

                this.PDF_BodySizeHorSelect_1 = {
                    index: { cellWidth: 35 }
                };
            }

            this.columnsSelector_1 = this.columnsSelectorDialog_1;

            if (this.columnsSelectorDialog_1.length == 0) {
                this.columns_index_1 = false;
                this.columns_fs_tname_1 = false;
                this.columns_user_fullname_1 = false;
                this.columns_action_type_1 = false;
                this.columns_action_time_1 = false;
                this.columns_topic_1 = false;

                this.columns_disabled_1 = false;
            } else if (this.columnsSelectorDialog_1.length == 6) {
                this.columns_index_1 = true;
                this.columns_fs_tname_1 = true;
                this.columns_user_fullname_1 = true;
                this.columns_action_type_1 = true;
                this.columns_action_time_1 = true;
                this.columns_topic_1 = true;

                this.columns_disabled_1 = true;
            } else {
                this.columns_disabled_1 = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector_1.length; index++) {
                    getData.push(this.columnsSelector_1[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector_1.length; index++) {
                    const element = this.columnsSelector_1[index].dataKey;

                    if (element == 'index') {
                        this.columns_index_1 = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index_1 = false;
                    }

                    if (element == 'user_username') {
                        this.columns_fs_tname_1 = true;
                    } else if (!getData.includes('user_username')) {
                        this.columns_fs_tname_1 = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname_1 = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname_1 = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_action_type_1 = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_action_type_1 = false;
                    }

                    if (element == 'action_time') {
                        this.columns_action_time_1 = true;
                    } else if (!getData.includes('action_time')) {
                        this.columns_action_time_1 = false;
                    }

                    if (element == 'topic') {
                        this.columns_topic_1 = true;
                    } else if (!getData.includes('topic')) {
                        this.columns_topic_1 = false;
                    }
                }
            }

            this.displayEditPDF_1 = false;
            this.filter = '';
        },
        CloseEditPDF_1() {
            this.displayEditPDF_1 = false;
        },
        ClearEditPDF_1() {
            this.columnsSelectorDialog_1 = [];
        },
        SelectAllEditPDF_1() {
            this.columnsSelectorDialog_1 = this.columns_1;
        }

        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT {
    width: 149px;
}

@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}

.stat-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    background-color: #fafafa;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #e0e0e0;
}

.stat-item:last-child {
    border-bottom: none;
}

.stat-label {
    font-weight: 600;
    color: #333;
}

.stat-value {
    font-size: 1.1rem;
    color: #007ad9;
}

.stat-note {
    font-size: 0.9rem;
    color: #666;
}
</style>
